// extracted by mini-css-extract-plugin
module.exports = {"list":"Items_list__37RHm","card":"Items_card__11JfE","loader":"Items_loader__2Notr"};